// localStorage pode lançar "The operation is insecure" (cookies bloqueados,
// modo privado, iframe restrito). Fallback em memória mantém a app funcional.
const memory = new Map();

const warn = (action, key, error) => {
  if (process.env.NODE_ENV !== "production") {
    console.warn(`safeStorage: ${action} de "${key}" indisponível, a usar memória`, error);
  }
};

export const safeStorage = {
  get(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      warn("leitura", key, error);
      return memory.has(key) ? memory.get(key) : null;
    }
  },
  set(key, value) {
    memory.set(key, value);
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      warn("escrita", key, error);
    }
  },
  remove(key) {
    memory.delete(key);
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      warn("remoção", key, error);
    }
  },
};
